<template>
  <div class="details_container" v-loading="loading">
    <div class="details_hint">员工领取的红包金额上限为200元</div>
    <div class="datails_data">
      <div>
        <div class="item_col">
          <span class="label">红包类型：</span>
          <span class="value">{{ detailsData.redpack_type == 1 ? '随机红包' : '固定红包' }}</span>
        </div>
        <div class="item_col">
          <span class="label">红包名称：</span>
          <span class="value">{{ detailsData.redpack_name || '-' }}</span>
        </div>
        <div class="item_col">
          <span class="label">红包数量：</span>
          <span class="value">{{ detailsData.total_num }}</span>
        </div>
        <div class="item_col">
          <span class="label">红包总额：</span>
          <span class="value">{{ detailsData.total_amount / 100 }}</span>
        </div>
        <div class="item_col">
          <span class="label">最小金额：</span>
          <span class="value">{{ detailsData.min_amount / 100 }}</span>
        </div>
        <div class="item_col">
          <span class="label">最大金额：</span>
          <span class="value">{{ detailsData.max_amount / 100 }}</span>
        </div>
        <div class="item_col">
          <span class="label">祝福语：</span>
          <span class="value">{{ detailsData.remark || '-' }}</span>
        </div>
        <div class="item_col">
          <span class="label">备注：</span>
          <span class="value">{{ detailsData.wishing || '-' }}</span>
        </div>
      </div>
      <div>
        <div class="item_col">
          <span class="label">发送状态：</span>
          <span class="value">{{ statusData[detailsData.send_status] || '-' }}</span>
        </div>
        <div class="item_col">
          <span class="label">发送时间：</span>
          <span class="value">{{ detailsData.send_time || '-' }}</span>
        </div>
        <div class="item_col">
          <span class="label">已领红包金额：</span>
          <span class="value">{{ detailsData.revd_amount / 100 }}</span>
        </div>
        <div class="item_col">
          <span class="label">已领红包数量：</span>
          <span class="value">{{ detailsData.revd_num }}</span>
        </div>
        <div class="item_col">
          <span class="label">未领红包金额：</span>
          <span class="value">{{ detailsData.unrevd_amount / 100 }}</span>
        </div>
        <div class="item_col">
          <span class="label">未领红包数量：</span>
          <span class="value">{{ detailsData.unrevd_num }}</span>
        </div>
        <div class="item_col">
          <span class="label max_label">未领金额是否已退回：</span>
          <span class="value">随机红包金额</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getRedpackSendRecordApi } from '@/api/enterpriseWeChatManagement';
export default {
  data() {
    return {
      id: this.$route.query.id,
      detailsData: {},
      statusData: {
        0: '未发送',
        1: '已发送',
        2: '发送失败',
      },
      loading: false,
    };
  },
  mounted() {
    this.getRedpackSendRecord();
  },
  methods: {
    getRedpackSendRecord() {
      this.loading = true;
      getRedpackSendRecordApi({
        id: this.id,
      })
        .then((res) => {
          this.loading = false;
          this.detailsData = res.brief_info;
        })
        .catch((e) => {
          this.loading = false;
          this.$message(e.message);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.details_container {
  background: #fff;
  padding: 24px;

  .details_hint {
    font-size: 12px;
    color: #939599;
  }

  .datails_data {
    display: flex;
    font-size: 14px;
    color: #313233;

    > div {
      flex: 1;

      &:nth-child(1) {
        border-right: 1px solid #edeff2;
      }

      &:nth-child(2) {
        padding-left: 24px;
      }
    }

    .item_col {
      height: 36px;
      line-height: 36px;
      margin-top: 16px;

      .label {
        display: inline-block;
        width: 98px;
        margin-right: 12px;
        &.max_label {
          width: 142px;
        }
      }
    }
  }
}
</style>
